import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  const { items = [], title } = props;
  const lastIndex = items.length - 1;

  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18"
              style={title ? { textTransform: "none" } : undefined}>
            {title || (items[lastIndex] ? items[lastIndex].label : "")}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {items.map((item, idx) => (
                <BreadcrumbItem key={idx} active={idx === lastIndex}>
                  {item.link && idx !== lastIndex ? (
                    <Link to={item.link}>{item.label}</Link>
                  ) : (
                    item.label
                  )}
                </BreadcrumbItem>
              ))}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired, // Accept React node, not just string
      link: PropTypes.string
    })
  )
}

export default Breadcrumb






// import React from "react"
// import PropTypes from 'prop-types'
// import { Link } from "react-router-dom"
// import { Row, Col, BreadcrumbItem } from "reactstrap"

// const Breadcrumb = props => {
//   return (
//     <Row>
//       <Col className="col-12">
//         <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//           <h4 className="mb-sm-0 font-size-18">{props.breadcrumbItem}</h4>
//           <div className="page-title-right">
//             <ol className="breadcrumb m-0">
//               <BreadcrumbItem>
//                 <Link to="#">{props.title}</Link>
//               </BreadcrumbItem>
//               <BreadcrumbItem active>
//                 <Link to="#">{props.breadcrumbItem}</Link>
//               </BreadcrumbItem>
//             </ol>
//           </div>
//         </div>
//       </Col>
//     </Row>
//   )
// }

// Breadcrumb.propTypes = {
//   breadcrumbItem: PropTypes.string,
//   title: PropTypes.string
// }

// export default Breadcrumb


